<template>
    <div>
        <Hero />
    </div>
</template>


<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import Hero from '@/components/Hero.vue'

export default {
    name: 'home',
    components: {
        Hero
    },

    methods: {
        toggleBodyClass(addRemoveClass, className) {
            const el = document.body;

            if (addRemoveClass === 'addClass') {
                el.classList.add(className);
            } else {
                el.classList.remove(className);
            }
        },

    },

    mounted() {
        this.toggleBodyClass('addClass', 'page-home');
    },

    destroyed() {
        this.toggleBodyClass('removeClass', 'page-home');
    }
  
}
</script>